import React, { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { ITicket } from '../../../../../services/tickets/types';
import { TICKET } from '../../../../../router/routes';
import { useAppSelector } from '../../../../../store/hooks';
import { PortalConfigSelector } from '../../../../../store/config/selectors';
import { PsaTypes } from '../../../../../services/config/types';

import useStyles from '../../../styles';
interface IProps {
  ticket: ITicket;
}

const TicketTitle: FC<IProps> = ({ ticket }) => {
  const classes = useStyles();
  const { psaType } = useAppSelector(PortalConfigSelector);

  const path = useMemo(() =>
      TICKET.replace(
        ':ticketId',
        psaType === PsaTypes.Autotask ? ticket?.ticketNumber ?? '' : ticket.id,
      ),
   [ticket.id, psaType, ticket.ticketNumber]);

  const ticketDescription = useMemo(
    () => (psaType === PsaTypes.Halo ? ticket.details : ticket.description),
    [ticket, psaType],
  );

  return (
        <Tooltip title={ticketDescription ? `Description: ${ticketDescription}` : undefined}>
          <Link to={path} className={classes.link}>{ticket.ticketNumber ?? ticket.id}</Link>
        </Tooltip>
  );
};

export default TicketTitle;
